/* eslint-disable react-hooks/rules-of-hooks */

import { React, useState } from "react";
import {
  RightLayoutContainer,
  PageTitleComp,
  TableLayoutData,
} from "../../styledElements";
import { Button, PageHeader, Table, Tooltip, Progress } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { Styled, GlobalSet, DisabledButtonStyle } from "../../pageStyled";
// import AddNewOrderData from "../OrderDetailDrawer/addNewOrder";

//new drawer with measurement changes
// import AddNewOrderData from "../OrderDetailDrawer/addOrderDrawer";
import MultiDiaAddOrderDrawer from "../OrderDetailDrawer/multiDiaAddOrderDrawer";
import { useEffect, useRef } from "react";
import {
  bulkChangeOrderState,
  deletePo,
  getAllOrdersListByPono,
  changeOrderPriority,
  deleteOrder,
  getAllOrdersListBySono,
} from "../../../Services/orderServices";
import moment from "moment";
import EditNewOrderDrawer from "../OrderDetailDrawer/editOrderDetails";
// import ResendApprovalData from "../OrderDetailDrawer/resendApproval";

//new drawer with measurement changes
// import ResendApprovalData from "../../OrderEntry/OrderDetailDrawer/resendApprovalNewDrawer";
import MultiDiaEditOrderDrawer from "../OrderDetailDrawer/multiDiaEditOrderDrawer";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import warning from "../../../Assets/Icons/warning.png";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertYellow from "../../../Assets/Icons/alertYellow.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import { useLocation, useNavigate } from "react-router";
import { ModalPopup } from "../../../Components/Modal/modal";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import SplitOrderDrawer from "../OrderDetailDrawer/splitOrderDrawer";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
import MergeDrawer from "../OrderDetailDrawer/MergeOrderDrawer";
import ActionDrawer from "../OrderDetailDrawer/ActionDrawer";
import ProductionDetailsDrawer from "../OrderDetailDrawer/productionDetailsDrawer";
import { Card } from "antd";
import { Row, Col, Dropdown, Menu } from "antd";
import styled from "styled-components";
import {
  currency_List,
  lengthUnit,
  weightUnit,
} from "../../../Utils/Constant/MeasurementUnitList";
import { getUnitData } from "../../../Services/measurementService";
import CancelQuantityDrawer from "../OrderDetailDrawer/cancelQuantityDrawer";
import ViewProcessedQuantityDrawer from "../OrderDetailDrawer/viewProcessedQuantityDrawer";
import ViewPendingQuantityDrawer from "../OrderDetailDrawer/PendingQuantityDrawer";
import { toHandlePOName } from "../../../Utils/helper/helper";
import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices";
import AddDummyOrderDrawer from "../OrderDetailDrawer/AddDummyOrderDrawer";
import AddNewDummyOrderDrawer from "../OrderDetailDrawer/AddNewDummyOrderDrawer";

const TooltipSelector = styled.div`
  .edit-tooltip .ant-tooltip-inner {
    padding: 7px !important;
    background: rgba(32, 31, 30, 0.85) !important;
    border-radius: 40px !important;
    font-family: var(--sf-pro-display-m);
    font-style: normal;
    font-size: 12px;
    line-height: 16px;
  }
  .edit-tooltip .ant-tooltip-placement-bottomRight .ant-tooltip-arrow {
    top: 3px;
    right: 13px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid black;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #ea655b !important;
    border-color: #dfe1e6 !important;
  }
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #ea655b !important;
  }
  .ant-checkbox-checked::after {
    border-color: #ea655b !important;
  }
`;

const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);

const OrderDetailsData = ({ showPo, poNo, customerName }) => {
  const navigate = useNavigate();
  const poDetails = useLocation();
  const [NewGradeSideDrawer, setNewGradeSideDrawer] = useState(false);
  const [resendApprovalData, setResendApprovalData] = useState(false);
  const [newOrderDrawer, setNewOrderDrawer] = useState(false);
  const [newDummyOrderDrawer, setNewDummyOrderDrawer] = useState(poDetails?.state?.dummyOrders ? true : false);
  const [allOrdersList, setAllOrdersList] = useState([]);
  const [allOrdersRecord, setAllOrdersRecord] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [rendering, setRendering] = useState(true);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [mergeSideDrawer, setMergeSideDrawer] = useState(false);
  const [isStateData, setStateData] = useState(false);

  // Toasters
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const [successApproval, setSuccessApproval] = useState(false);
  const [splitOrderSideDrawer, setSplitOrderSideDrawer] = useState(false);

  const [loading, setLoading] = useState(true);
  const [holdOrders, setHoldOrders] = useState(false);
  const [holdOrderDrawer, setHoldOrderDrawer] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [quantityDetails, setQuantityDetails] = useState();
  const [productionDetailsSideDrawer, setProductionDetailsSideDrawer] =
    useState(false);
  const [processedQtyDetailsSideDrawer, setProcessedQtyDetailsSideDrawer] =
    useState(false);
  const [pendingQtyDetailsSideDrawer, setPendingQtyDetailsSideDrawer] =
    useState(false);
  const [measurementData, setMeasurementData] = useState();
  const [cancelQuantitySideDrawer, setCancelQuantitySideDrawer] =
    useState(false);
  const [isVisiblePriorityModal, setIsVisiblePriorityModal] = useState(false);
  const [defaultActiveKey, setDefaultActiveKey] = useState(
    poDetails?.state?.defaultActiveKey
      ? poDetails?.state?.defaultActiveKey
      : "0"
  );
  const [orderState, setOrderState] = useState(
    poDetails?.state?.defaultOrderState
      ? poDetails?.state?.defaultOrderState
      : ""
  );
  const [isVisibleDeleteModal, setIsVisibleDeleteModal] = useState(false);
  const [isVisibleReleaseModal, setIsVisibleReleaseModal] = useState(false);
  const [soNumber, setSoNumber] = useState(poDetails.state.soNumber);
  const [orderManagementSettings, setOrderManagementSettings] = useState(JSON.parse(localStorage.getItem("order-management-settings")));

  const titleRef = useRef();
  const [tableStickyOffset, setTableStickyOffset] = useState(130);
  useEffect(() => {
    if (titleRef.current) {
      setTableStickyOffset(58 + titleRef.current.offsetHeight);
    }
  }, [quantityDetails, orderManagementSettings, poDetails]);
  var approvalData = allOrdersRecord
    .filter((order) => order.status === "Provisional")
    .map((item) => {
      return {
        order: item.orderno,
        state: "pending",
      };
    });

  const onChange = (pagination, filters, sorter, extra) => {
    if (pageSize !== pagination.pageSize) {
      setCurrentPage(1);
    } else {
      setCurrentPage(pagination.current);
    }
    setPageSize(pagination.pageSize);
  };

  const fetchAllOrders = async () => {

    try {
      const allOrdersData = poDetails.state.isSo
        ? await getAllOrdersListBySono(soNumber)
        : await getAllOrdersListByPono(poDetails?.state?.values?.poNumber);
      setQuantityDetails(allOrdersData?.quantity_details);
      setAllOrdersList(allOrdersData.data);
      setLoading(false);
    } catch (error) {
      setQuantityDetails({});
      setAllOrdersList([]);
      setLoading(false);
      console.log(error);
    }
  };

  const getAllOrders = () => {
    const orders = allOrdersList.map((item) => {
      let processQuantity;
      let pendingQuantity;
      let cancelledQuantity;
      let pendingQuantityValue;

      let quantityValue;
      let rewinderReels;
      if (item.type == "reel" && item.quantity_type == "reel_sheet") {
        pendingQuantityValue =
          item.this_item_type == "order"
            ? Math.round(item.total_pending_quantity.quantity)
            : Math.round(item.total_pending_quantity.quantity);
        processQuantity =
          item.this_item_type == "order"
            ? Math.round(item.total_processed_quantity.quantity) + " Reels"
            : Math.round(item.total_processed_quantity.quantity) + " Reels";
        pendingQuantity =
          item.this_item_type == "order"
            ? Math.round(item.total_pending_quantity.quantity) + " Reels"
            : Math.round(item.total_pending_quantity.quantity) + " Reels";
        cancelledQuantity =
          item.this_item_type == "order"
            ? Math.round(item.cancelled_quantity.quantity) + " Reels"
            : Math.round(item.total_cancelled_quantity.quantity) + " Reels";
        quantityValue =
          item.this_item_type == "order"
            ? Math.round(item.no_of_reel_sheet) + " Reels"
            : Math.round(item.total_quantity) + " Reels";
        rewinderReels =
          item.this_item_type == "order"
            ? Math.round(item.quantity)
            : Math.round(item.total_quantity);
      } else if (item.type == "sheet" && item.quantity_type == "reel_sheet") {
        quantityValue =
          item.this_item_type == "order"
            ? item.weight
              ? item.weight +
              " " +
              capitalize(weightUnit[item.units?.planned_weight].displayName)
              : "-"
            : item.total_weight
              ? item.total_weight +
              " " +
              capitalize(weightUnit[item.units?.total_weight].displayName)
              : "-";
        rewinderReels =
          item.this_item_type == "order"
            ? Math.round(item.quantity)
            : Math.round(item.total_quantity);
        processQuantity =
          item.this_item_type == "order"
            ? item.total_processed_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_processed_quantity.units?.weight]
                .displayName
            )
            : item.total_processed_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_processed_quantity.units?.weight]
                .displayName
            );
        pendingQuantity =
          item.this_item_type == "order"
            ? item.total_pending_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_pending_quantity.units?.weight]
                .displayName
            )
            : item.total_pending_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_pending_quantity.units?.weight]
                .displayName
            );
        cancelledQuantity =
          item.this_item_type == "order"
            ? item.cancelled_quantity.weight +
            " " +
            capitalize(weightUnit[item.cancelled_quantity.units].displayName)
            : item.total_cancelled_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_cancelled_quantity.units.weight]
                .displayName
            );
        pendingQuantityValue =
          item.this_item_type == "order"
            ? item.total_pending_quantity.weight
            : item.total_pending_quantity.weight;
      } else if (
        (item.type == "reel" || item.type == "sheet") &&
        item.quantity_type == "weight"
      ) {
        quantityValue =
          item.this_item_type == "order"
            ? item.weight
              ? item.weight +
              " " +
              capitalize(weightUnit[item.units?.planned_weight].displayName)
              : "-"
            : item.total_weight
              ? item.total_weight +
              " " +
              capitalize(weightUnit[item.units?.total_weight].displayName)
              : "-";
        rewinderReels =
          item.this_item_type == "order"
            ? Math.round(item.quantity)
            : Math.round(item.total_quantity);
        processQuantity =
          item.this_item_type == "order"
            ? item.total_processed_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_processed_quantity.units?.weight]
                .displayName
            )
            : item.total_processed_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_processed_quantity.units?.weight]
                .displayName
            );
        pendingQuantity =
          item.this_item_type == "order"
            ? item.total_pending_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_pending_quantity.units?.weight]
                .displayName
            )
            : item.total_pending_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_pending_quantity.units?.weight]
                .displayName
            );
        cancelledQuantity =
          item.this_item_type == "order"
            ? item.cancelled_quantity.weight +
            " " +
            capitalize(weightUnit[item.cancelled_quantity.units].displayName)
            : item.total_cancelled_quantity.weight +
            " " +
            capitalize(
              weightUnit[item.total_cancelled_quantity.units.weight]
                .displayName
            );
        pendingQuantityValue =
          item.this_item_type == "order"
            ? item.total_pending_quantity.weight
            : item.total_pending_quantity.weight;
      }

      let pendingValue;
      if (item.type === "sheet" && !item.core_id && !item.reel_od) {
        pendingValue = item.pending_quantity_weight;
      } else {
        pendingValue =
          item.quantity - item.completed - item.in_production - item.in_process;
      }

      let currencySymbol;
      if (item.units.net_price) {
        currencySymbol = currency_List.filter(
          (currUnit) => currUnit.code === item.units.net_price
        );
      } else {
        currencySymbol = "";
      }

      let currencySymbolDealer;
      if (item?.units?.dealer_price) {
        currencySymbolDealer = currency_List.filter(
          (currUnit) => currUnit.code === item.units.dealer_price
        );
      } else {
        currencySymbolDealer = "";
      }
      const balance_qty = (item?.balance_weight == 0) ? "-" : item?.balance_weight + " " + capitalize(item?.units?.weight);

      return {
        key: item.uuid,
        split_type: item.split_type,
        split_group: item.split_group,
        isEditAllowed: orderManagementSettings?.edit_after_approval?.value,
        isEditAllowed: orderManagementSettings?.edit_after_approval?.value,
        pono:
          item.po && typeof item.po === "string"
            ? item.po.toUpperCase()
            : item.po,

        sono:
          item.so && typeof item.so === "string"
            ? item.so.toUpperCase()
            : item.so,
        category: item.category,
        savedPO: item.po,
        groupno: item.split_group ? item.split_group : "-",
        orderno: item.number,
        createddate: moment(item.created_at).format("DD MMM YYYY"),
        customercode: item.customer,
        productcode: item.product,
        productspec: item.product_spec,
        type: capitalize(item.type),
        units: item.units ? item.units : "",
        size: `${item.width}${item.length ? `x${item.length}` : ""} ${item.units
            ? lengthUnit[item.units.width].displayName?.toUpperCase()
            : ""
          }`,
        quantity: `${quantityValue}`,
        weight: `${item.weight?.toFixed(3)}`,
        coreid: item.inner_dia ? `${item.inner_dia}` : "-",
        reelod: item.outer_dia ? `${item.outer_dia}` : "-",
        price: item.quoted_price
          ? `${item.units && currencySymbol ? currencySymbol[0].symbol : ""}` +
          " " +
          parseFloat(item.quoted_price).toFixed(2) +
          " " +
          `${item?.units?.per_weight_unit
            ? " /" +
            weightUnit[
              item.units.per_weight_unit
            ]?.displayName?.toUpperCase()
            : ""
          }`
          : "-",
        // netprice: item.net_price ? `${(item.units && currencySymbol)? currencySymbol[0].symbol : ""}`+ " " + parseFloat(item.net_price).toFixed(2) : "",
        netprice:
          item.net_price &&
            item.quantity_type == "reel_sheet" &&
            item.type == "reel"
            ? ""
            : item.net_price
              ? `${item.units && currencySymbol ? currencySymbol[0].symbol : ""
              }` +
              " " +
              parseFloat(item.net_price).toFixed(3)
              : "",
        dealerPrice: item.dealer_price
          ? `${item.units && currencySymbolDealer
            ? currencySymbolDealer[0].symbol
            : ""
          }` +
          " " +
          parseFloat(item.dealer_price).toFixed(3) +
          " " +
          `${item?.units?.per_weight_unit
            ? " / " +
            weightUnit[
              item.units.per_weight_unit
            ]?.displayName?.toUpperCase()
            : ""
          }`
          : "-",
        deliverydate:
          item.category === "so"
            ? "-"
            : moment(item.delivery_date).format("DD MMM YYYY"),
        approvedby: item.approved_by ? item.approved_by : "-",
        remarks: item.remarks,
        priority: item.forced,
        // Proper state values for 'changes req' and 'on hold'
        status: capitalize(
          // item.state === "review"
          //   ? "changes Req"
          //   : item.state === "hold"
          //   ? "On Hold"
          //   : item.state === "in_production"
          //   ? "In Production"
          //   : item.state === "cancel"
          //   ? "Cancelled"
          //   : item.state
          item.state === "review"
            ? "Changes Requested"
            : item.state === "hold"
              ? "On Hold"
              : item.state === "in_production"
                ? "In Production"
                : item.state === "cancel"
                  ? "Cancelled"
                  : item.state == "open"
                    ? "Provisional"
                    : item.state == "pending"
                      ? "Pending Confirmation"
                      : item.state == "rejected"
                        ? "Confirmation Rejected"
                        : item.state == "approved"
                          ? "Active"
                          : item.state == "produced"
                            ? "Produced"
                            : item.state
        ),
        completed: item.completed,
        in_production: item.in_production + item.in_process,
        // pending:
        //   item.quantity - item.completed - item.in_production - item.in_process,
        pending: pendingValue,
        customerName: item.customer_name,
        quantity_type: item.quantity_type,
        in_process: item.in_process,
        no_of_reel_sheet: `${item.no_of_reel_sheet}`,
        plannedweight: `${item.planned_weight?.toFixed(3)} ${item.units
            ? weightUnit[item.units.planned_weight].displayName?.toUpperCase()
            : ""
          }`,
        rewinder_reels: `${item.quantity}`,
        user: item.user,
        length: item.length,
        width: item.width,
        grain: item.grain,
        order_type: item.type,
        product_spec: item.product_spec,
        in_process: item.in_process,
        parent: item.parent,
        other_parents: item.other_parents,
        customer_alias: item.customer_alias,
        consignee_alias: item.consignee_alias,
        consignee_name: item.consignee_name,
        consignee: item.consignee,
        previous_state: item.previous_state,
        sheet_completed_weight: item.sheet_completed_weight
          ? item.sheet_completed_weight
          : 0,
        sheet_processed_weight: item.sheet_processed_weight
          ? item.sheet_processed_weight
          : 0,
        sheet_production_weight: item.sheet_production_weight
          ? item.sheet_production_weight
          : 0,
        pending_quantity_weight: item.pending_quantity_weight,
        cancelledQuantity,
        pendingQuantity,
        processQuantity,
        pendingQuantityValue,
        // total_pending_quantity : item.total_pending_quantity,
        // total_rewinder_quantity : item.total_rewinder_quantity,
        // total_sheet_quantity : item.total_sheet_quantity
        progressbar_info: item.progressbar_info,
        poDate: moment(
          item.category === "po" ? item.po_date : item.so_date
        ).format("DD MMM YYYY"),
        no_of_sheets: item.no_of_sheets,
        cancelled_quantity: item.cancelled_quantity,
        ply: item.ply,
        balance_qty: balance_qty,
      };
    });
    return orders;
  };

  const modalShow = () => {
    setIsVisibleModal(true);
  };

  const modalClose = () => {
    setIsVisibleModal(false);
  };

  const modalConfirm = () => {
    setIsVisibleModal(false);
    bulkChangeOrderState(approvalData)
      .then((response) => {
        setSuccessApproval(true);
        setTimeout(() => {
          setSuccessApproval(false);
        }, 2000);
        setRendering(true);
      })
      .catch((error) => {
        console.log("Error in changing state to approved", error);
      });
  };

  const ShowNewResendApproval = () => {
    setResendApprovalData(true);
  };
  const showNewGradeDrawer = () => {
    setNewGradeSideDrawer(true);
  };
  const showAddNewOrder = () => {
    !poDetails?.state?.dummyOrders ? setNewOrderDrawer(true) : setNewDummyOrderDrawer(true);
  };
  const onCloseNewGrade = () => {
    setNewGradeSideDrawer(false);
    setSplitOrderSideDrawer(false);
    setProductionDetailsSideDrawer(false);
    setSelectedOrder();
  };

  const onCloseAddNewOrder = () => {
    !poDetails?.state?.dummyOrders ? setNewOrderDrawer(false) : setNewDummyOrderDrawer(false);
  };
  const onCloseResendApproval = () => {
    setResendApprovalData(false);
    setSelectedOrder();
  };
  const onCloseFullNewGrade = () => {
    setNewGradeSideDrawer(false);
    setResendApprovalData(false);
    setNewOrderDrawer(false);
    setNewDummyOrderDrawer(false);
    setSplitOrderSideDrawer(false);
    setProductionDetailsSideDrawer(false);
    setProcessedQtyDetailsSideDrawer(false);
    setPendingQtyDetailsSideDrawer(false);
    setSelectedOrder();
  };

  // View and Edit actions
  const handleViewAction = (record) => {
    setSelectedOrder(record);
    showNewGradeDrawer();
  };

  const handleEditAction = (record) => {
    setSelectedOrder(record);
    ShowNewResendApproval();
  };

  const handleAddNewOrder = () => {
    showAddNewOrder();
  };

  const handleCancel = () => {
    showHoldOrder();
    // setOrderAction("hold");
    setNewGradeSideDrawer(false);
    setResendApprovalData(false);
  };

  const handleRestore = () => {
    setHoldOrders(false);
    setHoldOrderDrawer(false);
    ShowNewResendApproval();
    setNewGradeSideDrawer(false);
    // setResendApprovalData(false);
    // setOrderAction();
  };

  const handleHold = (record) => {
    showHoldDrawer(record);
  };

  const showHoldDrawer = (record) => {
    setNewGradeSideDrawer(false);
    setHoldOrderDrawer(true);
    setSelectedOrder(record);
  };

  const approvalHandler = () => {
    approvalData.length ? modalShow() : showYellowToaster();
  };

  const showPoPage = () => {
    goToPoDetails();
  };

  const showYellowToaster = () => {
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 2000);
  };

  // Show Toaster
  const showToaster = () => {
    setVisibleToaster(true);
    setTimeout(() => setVisibleToaster(false), 2000);
  };

  const goToOrderRecords = () => {
    if (poDetails.state?.backKey == "approveOrders") {
      navigate("../approve-records");
    } else {
      navigate("../order-records");
    }
  };

  const showHoldOrder = () => {
    setHoldOrders(true);
  };

  const onCloseActionDrawer = () => {
    setHoldOrders(false);
    setHoldOrderDrawer(false);
  };

  const goToPoDetails = () => {
    if (poDetails.state.values) {
      poDetails.state.values["backKey"] = poDetails.state.backKey;
      poDetails.state.values["route"] = poDetails.state.route;
    }

    poDetails.state.isSo
      ? poDetails.state.route === "so-details" || allOrdersRecord.length
        ? navigate("../so-details", {
          state: {
            soNumber: soNumber,
            isView: true,
            refNumber: poDetails?.state?.values?.refNumber,
            backKey: "../order-details",
            route: "add-new-so",
            dummyOrders: poDetails?.state?.dummyOrders

          },
        })
        : navigate("../add-new-so", {
          state: {
            values: poDetails.state.values,
            isData: true,
            refNumber: poDetails?.state?.values?.refNumber,
            cancelChangesDisable: allOrdersRecord.length ? true : false,
            isADD: true,
            route: "add-new-so",
            dummyOrders: poDetails?.state?.dummyOrders
          },
        })
      : poDetails.state.route === "po-details" || allOrdersRecord.length
        ? navigate("../po-details", { state: poDetails.state.values })
        : navigate("../add-new-po", {
          state: {
            values: poDetails.state.values,
            isData: true,
            cancelChangesDisable: allOrdersRecord.length ? true : false,
          },
        });
  };

  const handleSplitAction = (record) => {
    setSelectedOrder(record);
    showNewSplitOrderDrawer();
  };

  const showNewSplitOrderDrawer = () => {
    setNewGradeSideDrawer(false);
    setSplitOrderSideDrawer(true);
  };

  const showProductionDetailsDrawer = () => {
    setProductionDetailsSideDrawer(true);
  };

  const handleViewProdDetailsAction = (record) => {
    setSelectedOrder(record);
    setNewGradeSideDrawer(false);
    showProductionDetailsDrawer();
  };

  const handleViewProcessedQtyDetails = (record) => {
    if (record) {
      setSelectedOrder(record);
    }
    setNewGradeSideDrawer(false);
    showProcessedQtyDrawer();
  };

  const handleViewPendingQtyDetails = (record) => {
    if (record) {
      setSelectedOrder(record);
    }
    setNewGradeSideDrawer(false);
    showPendingQtyDrawer();
  };

  const showPendingQtyDrawer = () => {
    setPendingQtyDetailsSideDrawer(true);
  };

  const showProcessedQtyDrawer = () => {
    setProcessedQtyDetailsSideDrawer(true);
  };

  const handleCancelledQuantityAction = (record) => {
    setSelectedOrder(record);
    setNewGradeSideDrawer(false);
    setCancelQuantitySideDrawer(true);
  };

  const handleCancelQuantityDrawerClose = () => {
    setCancelQuantitySideDrawer(false);
    setSelectedOrder();
  };

  const handlePo = (record) => {
    setSelectedOrder(record);
    goToPoDetails();
  };

  // const goToPOPage = (record) => {
  //   record
  //     ? navigate("../po-details", {
  //       state: {
  //         poNumber: record.savedPO,
  //         backKey: "orderDetails",
  //       },
  //     })
  //     : navigate("../po-details", {
  //       state: {
  //         poNumber: selectedOrder.savedPO,
  //         backKey: "orderDetails",
  //       },
  //     });
  //   setNewGradeSideDrawer(false);
  //   setResendApprovalData(false);
  //   setSplitOrderSideDrawer(false);
  //   setProductionDetailsSideDrawer(false);
  //   setCancelQuantitySideDrawer(false);
  // };
  useEffect(async () => {
    const orderMangSettings = await getWorkflowSettings("order_management");
    setOrderManagementSettings(orderMangSettings.data);
  }, []);

  useEffect(() => {
    if (rendering) {
      fetchAllOrders();
      setRendering(false);
    }
  }, [rendering]);

  useEffect(() => {
    const ordersRecord = allOrdersList ? getAllOrders() : [];
    setAllOrdersRecord(ordersRecord);
    if (
      poDetails?.state?.selectedOrder &&
      !isStateData &&
      allOrdersList.length
    ) {
      setStateData(true);
      setSelectedOrder(poDetails.state.selectedOrder);
      setNewGradeSideDrawer(true);
      navigate(poDetails.pathname, {
        state: {
          route: poDetails.state.route,
          backKey: poDetails.state.backKey,
          values: poDetails.state.values,
        },
      });
    }
  }, [allOrdersList]);

  useEffect(() => {
    (async () => {
      try {
        const unitData = await getUnitData();
        if (!unitData.error) {
          setMeasurementData(unitData);
        }
      } catch (err) {
        console.log(err);
      }
    })();
  }, []);
  // Deleting po if all orders are deleted
  // useEffect(() => {
  //   if (isDeleted && !allOrdersRecord.length) {
  //     setIsDeleted(false);
  //     deletePo(poDetails.state.values.poNumber)
  //       .then((response) => {
  //         setActionToaster({
  //           error: response.error,
  //           msg: `${response.msg} since no Orders present`,
  //         });
  //         showToaster(setVisibleToaster);
  //         setTimeout(() => {
  //           navigate("../order-records");
  //         }, 3000);
  //       })
  //       .catch((error) => {
  //         console.log("Error in deleting po:", error);
  //         setActionToaster({
  //           error: error.response.error,
  //           msg: error.response.msg,
  //         });
  //         showToaster(setVisibleToaster);
  //       });
  //   }
  // }, [allOrdersRecord]);

  const columnsHead = [
    {
      title: "Po/So.No",
      dataIndex: "pono",
      width: "11.5%",
      fixed: "left",
      key: "pono",
      align: "left",
      sorter: () => { },
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.pono.localeCompare(b.pono),
      render: (text, record) => (
        <div className="">
          <Button
            style={{ background: "transparent" }}
            className="textTypeBtn textBtnIcon"
            onClick={() => handlePo(record)}
          >
            <div
              style={{
                whiteSpace: "normal",
                lineHeight: "1.2",
                textAlign: "left",
              }}
            >
              {`#${record.category === "po" ? toHandlePOName(record.pono) : toHandlePOName(record.sono)}`
                .match(/.{1,15}/g)
                ?.map((chunk, index) => (
                  <span key={index}>
                    {chunk}
                    <br />
                  </span>
                ))}
            </div>
          </Button>
        </div>
      ),
    },
    // {
    //   title: "Group No",
    //   dataIndex: "groupno",
    //   width: "6.5%",
    //   fixed: "left",
    //   sorter: () => {},
    //   // sortOrder: "null",
    // },
    {
      title: "Order No",
      dataIndex: "orderno",
      key: "orderno",
      width: "8%",
      fixed: "left",
      sorter: () => { },
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.orderno - b.orderno,
      render: (text, record) => (
        <div className="actionBtn2">
          {record?.previous_state?.old &&
            record?.previous_state?.new &&
            (record?.previous_state?.old === "review" ||
              record?.previous_state?.old === "approved" ||
              record?.previous_state?.old === "cancel") &&
            record.status === "Pending Confirmation" ? (
            // <Styled >
            <TooltipSelector>
              <Tooltip
                overlayInnerStyle={{
                  borderRadius: "8px",
                  background: "rgba(32, 31, 30, 0.85)",
                  padding: "7px",
                  background: "rgba(32, 31, 30, 0.85)",
                  fontFamily: "var(--sf-pro-display-m)",
                  fontStyle: "normal",
                  fontSize: "12px",
                  lineHeight: "16px",
                }}
                placement="bottomRight"
                title={
                  record?.previous_state?.old === "review"
                    ? "This order has been sent for approval again. Changes were requested in this order previously."
                    : record?.previous_state?.old === "cancel"
                      ? "This order has been sent for approval again. This order was cancelled previously."
                      : "This order has been sent for approval again. This order was approved previously."
                }
                // getPopupContainer={(triggerNode) => triggerNode}
                overlayClassName="edit-tooltip"
              >
                <Button
                  style={{ background: "transparent" }}
                  className="textTypeBtn textBtnIcon"
                  onClick={() => handleViewAction(record)}
                >
                  {`${text}`}
                </Button>
              </Tooltip>
            </TooltipSelector>
          ) : text != "-" ? (
            // </Styled>
            <Button
              style={{ background: "transparent" }}
              className="textTypeBtn textBtnIcon"
              onClick={() => handleViewAction(record)}
            >
              {`${text}`}
            </Button>
          ) : (
            <span style={{ textAlign: "center" }}>{text}</span>
          )}
          {record?.previous_state?.old &&
            record?.previous_state?.new &&
            (record?.previous_state?.old === "review" ||
              record?.previous_state?.old === "approved" ||
              record?.previous_state?.old === "cancel") &&
            record.status === "Pending Confirmation" && (
              <div>
                <span
                  style={{
                    color: "rgb(234, 101, 91)",
                    fontStyle: "italic",
                    fontSize: "10px",
                  }}
                >
                  Resent for approval
                </span>
              </div>
            )}
        </div>
      ),
    },
    {
      title: "PO/SO Date",
      dataIndex: "poDate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => new Date(a.poDate) - new Date(b.poDate),
      },
    },
    {
      title: "Customer",
      dataIndex: "customer_alias",
      width: "7%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.customercode}-${record.customerName}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.customer_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    {
      title: "Consignee",
      dataIndex: "consignee_alias",
      width: "7%",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn2">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={`${record.consignee}-${record.consignee_name}`}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {record?.consignee_alias || "-"}
            </Tooltip>
          </Styled>
        </div>
      ),
    },
    // {
    //   title: "Prod. Code",
    //   dataIndex: "productcode",
    //   width: "5.8%",
    // },
    {
      title: (
        <div>
          Product
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      render: (text, record) => (
        <Styled>
          {" "}
          <span style={{ fontSize: "10px" }}>{record.productspec} </span>
          <br />
          <span style={{ textAlign: "center" }}>{record.productcode}</span>
        </Styled>
      ),
      //dataIndex: "productspec",
      width: "10.8%",
    },
    // {
    //   title: "Type",
    //   dataIndex: "type",
    //   width: "5.8%",
    // },
    {
      title: "Size(WxL)",
      dataIndex: "size",
      width: "8.4%",
    },
    {
      title: "PLY",
      dataIndex: "ply",
      width: "8.4%",
    },
    {
      title: "Order Quantity",
      dataIndex: "quantity",
      width: "7.4%",
      render: (text, record) => (
        <Styled>
          {" "}
          {record.type.toLowerCase() == "sheet" &&
            record.quantity_type.toLowerCase() == "reel_sheet" ? (
            <>
              <span style={{ textAlign: "center" }}>{text}</span>
              <br /> <span> {record.no_of_sheets + " Sheets"} </span>
            </>
          ) : (
            `${text} `
          )}
        </Styled>
      ),
    },
    {
      title: "Balance Quantity",
      dataIndex: "balance_qty",
      width: "7.4%",
    },
    {
      title: "Processed Quantity",
      dataIndex: "processQuantity",
      width: "7.4%",
      render: (text, record) => {
        return (
          <div
            className="actionBtn"
            style={{ marginTop: "14px", justifyContent: "left" }}
          >
            <Col span={12}>
              {parseFloat(text) && record.type
                ? `${text}`
                : parseFloat(text)
                  ? `${text} `
                  : "-"}
            </Col>
            {parseFloat(text) ? (
              <Col span={12}>
                <Styled style={{ marginTop: "-8px" }}>
                  <Tooltip
                    placement="bottomRight"
                    title={"View Processed Quantity Details"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        handleViewProcessedQtyAction(record);
                      }}
                    >
                      <Iconmoon
                        icon="viewPODetails"
                        size={16}
                        color="rgb(96, 94, 92)"
                      />
                    </Button>
                  </Tooltip>
                </Styled>
              </Col>
            ) : (
              ""
            )}
          </div>
        );
      },
    },
    {
      title: "Pending Quantity",
      dataIndex: "pendingQuantity",
      width: "7.4%",
      render: (text, record) => {
        return (
          <div
            className="actionBtn"
            style={{ marginTop: "14px", justifyContent: "left" }}
          >
            <Col span={12}>
              {parseFloat(text) && record.type
                ? `${text}`
                : parseFloat(text)
                  ? `${text} `
                  : "-"}
            </Col>
            {parseFloat(text) ? (
              <Col span={12}>
                <Styled style={{ marginTop: "-8px" }}>
                  <Tooltip
                    placement="bottomRight"
                    title={"View Pending Quantity Details"}
                    className="edit-tooltip"
                    getPopupContainer={(triggerNode) => triggerNode}
                  >
                    <Button
                      onClick={() => {
                        handleViewPendingQtyAction(record);
                      }}
                    >
                      <Iconmoon
                        icon="viewPODetails"
                        size={16}
                        color="rgb(96, 94, 92)"
                      />
                    </Button>
                  </Tooltip>
                </Styled>
              </Col>
            ) : (
              ""
            )}
          </div>
        );
      },
    },
    {
      title: "Cancelled Quantity",
      dataIndex: "cancelledQuantity",
      width: "7.4%",
      render: (text, record) =>
        parseFloat(text) && record.type
          ? `${text}`
          : parseFloat(text)
            ? `${text}`
            : "-",
    },
    // {
    //   title: "Order Weight",
    //   dataIndex: "weight",
    //   width: "9%",
    //   render: (text, record) =>
    //     record.quantity_type === "reel_sheet" ? "-" : `${text} ${record.units  && record.item_type !== "split_group" ? weightUnit[record.units.weight]?.displayName?.toUpperCase() : weightUnit[record.units.total_weight]?.displayName.toUpperCase()}`,
    // },
    // {
    //   title: "Planned Weight",
    //   dataIndex: "plannedweight",
    //   width: "9%",
    //   render: (text, record) =>
    //     parseFloat(text.split(" ")[0]) ? record.plannedweight : "-",
    // },
    // {
    //   title: "Core ID",
    //   dataIndex: "coreid",
    //   width: "6%",
    //   render: (text, record) =>
    //     parseFloat(text.split(" ")[0]) ? record.coreid : "-",
    // },
    // {
    //   title: "Reel OD",
    //   dataIndex: "reelod",
    //   width: "6%",
    //   render: (text, record, index) => (
    //     <Styled>
    //       <div style={{ display: "flex" }}>
    //         {record.id_od_type == "range" && (
    //           <div
    //             style={{
    //               color: "var(--para-text)",
    //               display: "flex",
    //               width: "100%",
    //               alignSelf: "center",
    //             }}
    //           >
    //             {record.minimum_reel_od +
    //               "-" +
    //               record.maximum_reel_od +
    //               " " +
    //               lengthUnit[record.units.maximum_reel_od].displayName}
    //           </div>
    //         )}
    //         {record.id_od_type == "constant" && (
    //           <div
    //             style={{
    //               display: "flex",
    //               width: "70%",
    //               flexDirection: "column",
    //               alignSelf: "center",
    //             }}
    //           >
    //             {record.reelod &&
    //               record.reelod?.map((item, index) => {
    //                 return (
    //                   index < 2 && (
    //                     <div>
    //                       {item}{" "}
    //                       {index == 1
    //                         ? "...,"
    //                         : record.reelod.length > 1
    //                         ? ","
    //                         : ""}
    //                     </div>
    //                   )
    //                 );
    //               })}

    //             {record.reelod &&
    //               record.reelod?.length >= 2 &&
    //               record.reelod?.map((item, index) => {
    //                 let tooltipData = "";
    //                 for (
    //                   let index = 2;
    //                   index < record.reelod?.length;
    //                   index++
    //                 ) {
    //                   const data = record.reelod[index];
    //                   tooltipData = tooltipData + data + ", ";
    //                 }
    //                 tooltipData = tooltipData.substring(
    //                   0,
    //                   tooltipData.length - 1
    //                 );
    //                 return (
    //                   index == 2 && (
    //                     <Tooltip title={tooltipData}>
    //                       {" "}
    //                       <span
    //                         style={{
    //                           display: "flex",
    //                           fontSize: "10px",
    //                           fontWeight: "bold",
    //                         }}
    //                       >
    //                         & {record.reelod.length - 2} More
    //                       </span>
    //                     </Tooltip>
    //                   )
    //                 );
    //               })}
    //           </div>
    //         )}
    //       </div>
    //     </Styled>
    //   ),
    // },
    // {
    //   title: "Rewinder Reels",
    //   dataIndex: "rewinder_reels",
    //   width: "9%",
    //   render: (text, record) => (parseFloat(text) ? `${text} Reels` : "-"),
    // },
    // {
    //   title: "QUO.PRICE",
    //   dataIndex: "price",
    //   width: "8%",
    //   // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.price}</div> : "-",
    // },
    {
      title: "Price",
      width: "8%",
      render: (text, record) => (
        <Styled>
          {record.category === "so" ? (
            "-"
          ) : (
            <>
              {record.type !== "reel" &&
                record.quantity_type !== "reel_sheet" && (
                  <span style={{ fontSize: "10px" }}>{record.netprice}</span>
                )}
              <br />
              <span style={{ textAlign: "center" }}>
                Rate: {record.dealerPrice}
              </span>
            </>
          )}
        </Styled>
      ),
      // render: (text, record) => parseFloat(text.split(" ")[0]) ? <div>&#8377;{record?.netprice}</div> : "-",
    },
    {
      title: "Delivery Date",
      dataIndex: "deliverydate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => new Date(a.deliverydate) - new Date(b.deliverydate),
      },
      // sortOrder: "null",
      // sorter: (a, b, sortOrder) => a.deliverydate.localeCompare(b.deliverydate),
    },
    {
      title: "Created Date",
      dataIndex: "createddate",
      width: "7.3%",
      sorter: {
        compare: (a, b) => new Date(a.createddate) - new Date(b.createddate),
      },
      // sorter: (a, b, sortOrder) => a.createddate.localeCompare(b.createddate),
    },

    {
      title: "Approver By",
      dataIndex: "approvedby",
      width: "6.4%",
      align: "center",
      render: (text, record) =>
        record.status === "Provisional" || record.status === "Pending Confirmation" ? "-" : text,
    },
    {
      title: "Priority",
      dataIndex: "priority",
      width: "5%",
      render: (text, record) => (
        <div className="actionBtn">
          <Button style={{ cursor: "default" }}>
            <Iconmoon
              icon={record.priority ? "correct" : "wrong"}
              size={16}
              color={record.priority ? "#3FBD61" : "#a19f9d"}
            />
          </Button>
        </div>
      ),
      align: "center",
    },
    // {
    //   title: "Remarks",
    //   dataIndex: "remarks",
    //   width: "6%",
    //   render: (text, record) => (
    //     <div className="actionBtn">
    //       <Styled>
    //         <Tooltip
    //           placement="bottomRight"
    //           title={record.remarks}
    //           className="edit-tooltip"
    //           getPopupContainer={(triggerNode) => triggerNode}
    //         >
    //           <Button style={{ cursor: "default" }}>
    //             <Iconmoon icon="message" size={16} color="#EA655B" />
    //           </Button>
    //         </Tooltip>
    //       </Styled>
    //     </div>
    //   ),
    //   align: "center",
    // },

    {
      title: "Status",
      dataIndex: "status",
      width: "7.6%",
      render: (text, record) => (
        <div className="statusVal" dataval={record.status}>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={
                record.status === "Changes Requested"
                  ? "The approver has requested changes in this order. Click on View Order to see approver remarks"
                  : (record.status === "Approved" || record.status === "Active")
                    ? "The order has been approved"
                    : (record.status === "Pending" || record.status === "Pending Confirmation")
                      ? "The order is pending for approval"
                      : (record.status === "Open" || record.status === "Provisional")
                        ? "The order is not sent for approval yet. Go to PO to send orders for approval"
                        : (record.status === "Rejected" || record.status === "Confirmation Rejected")
                          ? "The order is rejected by the approver. Click on View Order to see approver remarks"
                          : record.status === "On Hold"
                            ? "The order has been put on hold by the approver"
                            : record.status === "Cancelled"
                              ? "The order has been cancelled"
                              : record.status === "Merged"
                                ? "The quantity in this order is merged with other orders"
                                : record.status === "Produced"
                                  ? "The order has been produced"
                                  : null
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {" "}
              {record.status === "In_production" ? "Active" : record.status}
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Progress",
      dataIndex: "progress",
      width: "6.8%",
      render: (text, record) => {
        // if(record.item_type && record.item_type === "order"){
        if (
          record?.order_type === "sheet" ||
          (record?.order_type === "reel" && record?.quantity_type === "weight")
        ) {
          const totalProd =
            ((record?.progressbar_info?.completed?.weight +
              record?.progressbar_info?.in_production?.weight) /
              (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
            100;
          const totalCompleted =
            (record?.progressbar_info?.completed?.weight /
              (parseFloat(record.weight) - record.cancelled_quantity?.weight)) *
            100;
          //const weightUnitKey =  ((record?.units && record?.units?.weight) ? capitalize(weightUnit[record.units.weight]?.displayName) : "T") ;
          return (
            <div className="progressLvl">
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={`${record?.progressbar_info?.completed
                      ? (record?.progressbar_info?.completed?.weight).toFixed(3)
                      : 0.0
                    } ${capitalize(
                      weightUnit[
                        record?.progressbar_info?.completed?.units?.weight
                      ].displayName
                    )} Weight produced
                          ${record?.progressbar_info?.in_production
                      ? (record?.progressbar_info?.in_production?.weight).toFixed(
                        3
                      )
                      : 0.0
                    } ${capitalize(
                      weightUnit[
                        record?.progressbar_info?.in_production?.units?.weight
                      ].displayName
                    )} Weight in production
                        ${record?.progressbar_info?.pending
                      ? (record?.progressbar_info?.pending?.weight).toFixed(
                        3
                      )
                      : 0.0
                    } ${capitalize(
                      weightUnit[record?.progressbar_info?.pending?.units?.weight]
                        .displayName
                    )} Weight pending for deckle match`}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Progress
                    percent={totalProd}
                    success={{
                      percent: totalCompleted,
                    }}
                    strokeColor={"#cbe2cd"}
                  />
                </Tooltip>
              </Styled>
            </div>
          );
        } else {
          const production =
            ((record?.progressbar_info?.completed?.quantity +
              record?.progressbar_info?.in_production?.quantity) /
              (record?.no_of_reel_sheet -
                record.cancelled_quantity?.quantity)) *
            100;
          const completed =
            (record?.progressbar_info?.completed?.quantity /
              (record?.no_of_reel_sheet -
                record.cancelled_quantity?.quantity)) *
            100;

          return (
            <div className="progressLvl">
              <Styled>
                <Tooltip
                  placement="bottomRight"
                  title={`${record?.progressbar_info?.completed
                      ? record?.progressbar_info?.completed?.quantity
                      : 0
                    } Reels produced
                          ${record?.progressbar_info?.in_production
                      ? record?.progressbar_info?.in_production
                        ?.quantity
                      : 0
                    } Reels in production
                          ${record?.progressbar_info?.pending
                      ? record?.progressbar_info?.pending?.quantity
                      : 0
                    } Reels pending for deckle match`}
                  className="edit-tooltip"
                  getPopupContainer={(triggerNode) => triggerNode}
                >
                  <Progress
                    percent={production}
                    success={{
                      percent: completed,
                    }}
                    strokeColor={"#cbe2cd"}
                  />
                </Tooltip>
              </Styled>
            </div>
          );
        }
      },
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "10%",
      render: (text, record) => (
        <div className="actionBtn">
          {!["Confirmation Rejected", "On Hold", "Produced", "Cancelled", "Merged"].includes(
            record?.status
          ) &&
            (userDetails?.roles?.order_records.edit_all ||
              (userDetails?.roles?.order_records.edit_own &&
                userDetails.id == record.user)) &&
            ((record?.status == "Active" &&
              record?.completed == 0 &&
              record?.in_production == 0) ||
              record?.status !== "Active") && record.isEditAllowed ? (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"Edit this order"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => {
                    handleEditAction(record);
                  }}
                >
                  <Iconmoon icon="edit" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          ) : (
            <div style={{ display: "flex" }}>
              <div style={{ width: "35px" }}></div>
            </div>
          )}
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View details of this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() => {
                  handleViewAction(record);
                }}
              >
                <Iconmoon icon="file-view" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
          {/* {(((userDetails?.roles?.order_records.edit_all) || ((userDetails?.roles?.order_records.edit_own) && (userDetails.id == record.user))) && ((record?.status == "Approved") && (!record?.priority) && (record?.pending != 0))) ? (
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"Split this order"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() => {
                  handleSplitAction(record);
                }}
              >
              <Iconmoon icon={"Mapping"} size={17} color="#A19F9D" />                
              </Button>
            </Tooltip>
          </Styled>
          ): (
            <div style={{ display: "flex" }}>
              <div style={{ width: "35px" }}></div>
            </div>
          )}
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View Production Details"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={() => {
                  handleViewProdDetailsAction(record);
                }}
              >
                <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
              </Button>
            </Tooltip>
          </Styled> */}
          {/* { <Dropdown
                overlay={
                  <Menu>
                    
                    { 
                      (userDetails?.roles?.order_records.edit_all ||
                        (userDetails?.roles?.order_records.edit_own &&
                          userDetails.id == record.user)) &&
                      record?.status == "Approved" &&
                      !record?.priority &&
                      record?.pending != 0  && ( <Menu.Item key="2" style={{padding: "0px 12px"}}>
                            <Button
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color : 'black',
                            }}
                            className="themeBtn noBg"
                              onClick={() => {
                                handleSplitAction(record);
                              }}
                            >
                              <div style={{display: "flex", flexDirection: "row"}}>
                                <div style={{marginTop: "8px"}}>
                              <Iconmoon
                                icon={"Mapping"}
                                size={17}
                                color="#605E5C"
                              /> </div><div style={{marginTop: "5px", marginLeft: "6px"}}>Split this order</div>
                              
                              </div>
                            </Button>
                        </Menu.Item>) 
                    }
                    {
                      <Menu.Item key="3" style={{padding: "0px 12px"}}>
                      <Button
                      style={{
                        border: "none",
                        background: "none",
                        padding: "0",
                        font: "inherit",
                        textAlign: "left",
                        width: "100%",
                        color : 'black',
                      }}
                      className="themeBtn noBg"
                      onClick={() => {
                        handleViewProdDetailsAction(record);
                      }}
                      >
                        <div style={{display: "flex", flexDirection: "row"}}>
                          <div style={{marginTop: "8px"}}>
                        <Iconmoon
                          icon={"production"}
                          size={17}
                          color="#605E5C"
                        /> </div><div style={{marginTop: "5px", marginLeft: "6px"}}>View Production Details</div>
                        
                        </div>
                      </Button>
                      </Menu.Item>
                    }
                    { [ "Approved"].includes(record?.status) && (parseFloat( record.pendingQuantityValue) > parseFloat(0)) && ( <Menu.Item key="4" style={{padding: "0px 12px"}}>
                      <Button
                      style={{
                        border: "none",
                        background: "none",
                        padding: "0",
                        font: "inherit",
                        textAlign: "left",
                        width: "100%",
                        color : 'black',
                      }}
                      className="themeBtn noBg"
                      onClick={() => {
                        handleCancelledQuantityAction(record);
                      }}
                      >
                        <div style={{display: "flex", flexDirection: "row"}}>
                          <div style={{marginTop: "8px"}}>
                        <Iconmoon
                          icon={"production"}
                          size={17}
                          color="#605E5C"
                        /> </div><div style={{marginTop: "5px", marginLeft: "6px"}}>Cancel Quantity</div>
                        
                        </div>
                      </Button>
                      </Menu.Item>)
                    }
                  </Menu>
                }
                placement="bottom"
                arrow
              >
                <DisabledButtonStyle>
                <Button
                  
                >
                  <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
                </Button>
                </DisabledButtonStyle>
              </Dropdown>  } */}
          {
            <Dropdown
              overlay={
                <Menu>
                  {(userDetails?.roles?.order_records.edit_all ||
                    userDetails?.roles?.order_records.edit_own) &&
                    record?.status == "Active" && record.isEditAllowed && (
                      <Menu.Item key="1" style={{ padding: "0px 12px" }}>
                        <Button
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                          onClick={() => {
                            handlePriorityAction(record);
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "8px" }}>
                              <Iconmoon
                                icon={
                                  record.priority
                                    ? "low-priority"
                                    : "high-priority"
                                }
                                size={17}
                                color={record.priority ? "#ea4e2c" : "#3fbd61"}
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "5px", marginLeft: "6px" }}
                            >
                              {record.priority
                                ? "Remove Priority"
                                : "Prioritize this order"}
                            </div>
                          </div>
                        </Button>
                      </Menu.Item>
                    )}
                  {(userDetails?.roles?.order_records.edit_all ||
                    (userDetails?.roles?.order_records.edit_own &&
                      userDetails.id == record.user)) &&
                    record?.status == "Active" &&
                    !record?.priority &&
                    record?.pendingQuantityValue != 0 && record.isEditAllowed && (
                      <Menu.Item key="2" style={{ padding: "0px 12px" }}>
                        <Button
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                          onClick={() => {
                            handleSplitAction(record);
                          }}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "8px" }}>
                              <Iconmoon
                                icon={"Mapping"}
                                size={17}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "5px", marginLeft: "6px" }}
                            >
                              Split this order
                            </div>
                          </div>
                        </Button>
                      </Menu.Item>
                    )}
                  {record.status !== "Cancelled" &&
                    record?.split_type != "auto" &&
                    record.split_group &&
                    record.status == "Active" &&
                    !record?.priority &&
                    record.completed == 0 &&
                    record.in_production == 0 &&
                    record.in_process == 0 &&
                    record.parent && record.isEditAllowed && (
                      <Menu.Item key="3" style={{ marginBottom: "-10px" }}>
                        <DisabledButtonStyle>
                          <Button
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                            onClick={() =>
                              onMergeOrderHandler(record, "menuEle")
                            }
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div style={{ marginTop: "-1px" }}>
                                <Iconmoon
                                  icon={"export"}
                                  size={14}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{
                                  marginTop: "-3px",
                                  marginLeft: "11px",
                                }}
                              >
                                Merge order
                              </div>
                            </div>
                          </Button>
                        </DisabledButtonStyle>
                      </Menu.Item>
                    )}
                  {record.status == "Active" &&
                    record.pendingQuantityValue > 0 && record.isEditAllowed && (
                      <Menu.Item key="4" style={{ marginBottom: "-10px" }}>
                        <Button
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                          onClick={() => handleCancelledQuantityAction(record)}
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "0px" }}>
                              <Iconmoon
                                icon={"wrong"}
                                size={15}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "-2px", marginLeft: "6px" }}
                            >
                              Cancel Quantity
                            </div>
                          </div>
                        </Button>
                      </Menu.Item>
                    )}
                  {["On Hold", "Active"].includes(record?.status) && (
                    <Menu.Item key="5" style={{ padding: "0px 12px" }}>
                      <Button
                        style={{
                          border: "none",
                          background: "none",
                          padding: "0",
                          font: "inherit",
                          textAlign: "left",
                          width: "100%",
                          color: "black",
                        }}
                        className="themeBtn noBg"
                        onClick={() => {
                          handleViewProdDetailsAction(record);
                        }}
                      >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <div style={{ marginTop: "8px" }}>
                            <Iconmoon
                              icon={"production"}
                              size={17}
                              color="#605E5C"
                            />{" "}
                          </div>
                          <div style={{ marginTop: "5px", marginLeft: "6px" }}>
                            View Production Details
                          </div>
                        </div>
                      </Button>
                    </Menu.Item>
                  )}
                  {["On Hold", "Active"].includes(record?.status) ? (
                    <Menu.Item key="6" style={{ padding: "0px 12px" }}>
                      <Button
                        style={{
                          border: "none",
                          background: "none",
                          padding: "0",
                          font: "inherit",
                          textAlign: "left",
                          width: "100%",
                          color: "black",
                        }}
                        className="themeBtn noBg"
                        onClick={() => {
                          handleViewProcessedQtyDetails(record);
                        }}
                      >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <div style={{ marginTop: "8px" }}>
                            <Iconmoon
                              icon={"viewPODetails"}
                              size={17}
                              color="#605E5C"
                            />{" "}
                          </div>
                          <div style={{ marginTop: "5px", marginLeft: "6px" }}>
                            View Processed Quantity Details
                          </div>
                        </div>
                      </Button>
                    </Menu.Item>
                  ) : (
                    ""
                  )}
                  {[
                    "On Hold",
                    "Active",
                    "Provisional",
                    "Changes Requested",
                    "Pending Confirmation",
                  ].includes(record?.status) && (
                      <Menu.Item key="7" style={{ padding: "0px 12px" }}>
                        <Button
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                          onClick={() => {
                            handleViewPendingQtyDetails(record);
                          }}
                        >
                          <div style={{ display: "flex", flexDirection: "row" }}>
                            <div style={{ marginTop: "8px" }}>
                              <Iconmoon
                                icon={"viewPODetails"}
                                size={17}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div style={{ marginTop: "5px", marginLeft: "6px" }}>
                              View Pending Quantity Details
                            </div>
                          </div>
                        </Button>
                      </Menu.Item>
                    )}
                  <Menu.Item key="8" style={{ marginBottom: "-10px" }}>
                    <DisabledButtonStyle>
                      <Button
                        onClick={() => {
                          onViewPODetailsHandler(record);
                        }}
                        style={{
                          border: "none",
                          background: "none",
                          padding: "0",
                          font: "inherit",
                          textAlign: "left",
                          width: "100%",
                          color: "black",
                        }}
                        className="themeBtn noBg"
                      >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <div style={{ marginTop: "0px" }}>
                            <Iconmoon
                              icon={"viewPODetails"}
                              size={17}
                              color="#605E5C"
                            />{" "}
                          </div>
                          <div style={{ marginTop: "-2px", marginLeft: "6px" }}>
                            {record?.category === "po"
                              ? "View PO Details"
                              : "View SO Details"}
                          </div>
                        </div>
                      </Button>{" "}
                    </DisabledButtonStyle>
                  </Menu.Item>
                  <Menu.Item key="9" style={{ marginBottom: "-10px" }}>
                    <DisabledButtonStyle>
                      <Button
                        onClick={() => {
                          onViewChangeHandler(record);
                        }}
                        style={{
                          border: "none",
                          background: "none",
                          padding: "0",
                          font: "inherit",
                          textAlign: "left",
                          width: "100%",
                          color: "black",
                        }}
                        className="themeBtn noBg"
                      >
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <div style={{ marginTop: "0px" }}>
                            <Iconmoon
                              icon={"changeHistory"}
                              size={19}
                              color="#605E5C"
                            />{" "}
                          </div>
                          <div style={{ marginTop: "-2px", marginLeft: "5px" }}>
                            View Change History
                          </div>
                        </div>
                      </Button>{" "}
                    </DisabledButtonStyle>
                  </Menu.Item>
                  {record.status == "Provisional" && record.isEditAllowed && (
                    <Menu.Item key="10" style={{ marginBottom: "-10px" }}>
                      <DisabledButtonStyle>
                        <Button
                          onClick={() => handleDelete(record)}
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "0px" }}>
                              <Iconmoon
                                icon={"production"}
                                size={17}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "-2px", marginLeft: "6px" }}
                            >
                              Delete Order
                            </div>
                          </div>
                        </Button>{" "}
                      </DisabledButtonStyle>
                    </Menu.Item>
                  )}
                  {record.status == "Active" &&
                    record.pendingQuantityValue && record.isEditAllowed && (
                      <Menu.Item key="11" style={{ marginBottom: "-10px" }}>
                        <DisabledButtonStyle>
                          <Button
                            onClick={() => handleHold(record)}
                            style={{
                              border: "none",
                              background: "none",
                              padding: "0",
                              font: "inherit",
                              textAlign: "left",
                              width: "100%",
                              color: "black",
                            }}
                            className="themeBtn noBg"
                          >
                            <div
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <div
                                style={{ marginTop: "0px", marginLeft: "2px" }}
                              >
                                <Iconmoon
                                  icon={"hold"}
                                  size={14}
                                  color="#605E5C"
                                />{" "}
                              </div>
                              <div
                                style={{ marginTop: "-2px", marginLeft: "9px" }}
                              >
                                Hold Order
                              </div>
                            </div>
                          </Button>{" "}
                        </DisabledButtonStyle>
                      </Menu.Item>
                    )}
                  {record.status == "On Hold" && record.isEditAllowed && (
                    <Menu.Item key="12" style={{ marginBottom: "-10px" }}>
                      <DisabledButtonStyle>
                        <Button
                          onClick={() => handleRelease(record)}
                          style={{
                            border: "none",
                            background: "none",
                            padding: "0",
                            font: "inherit",
                            textAlign: "left",
                            width: "100%",
                            color: "black",
                          }}
                          className="themeBtn noBg"
                        >
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                          >
                            <div style={{ marginTop: "0px" }}>
                              <Iconmoon
                                icon={"production"}
                                size={17}
                                color="#605E5C"
                              />{" "}
                            </div>
                            <div
                              style={{ marginTop: "-2px", marginLeft: "6px" }}
                            >
                              Release Order
                            </div>
                          </div>
                        </Button>{" "}
                      </DisabledButtonStyle>
                    </Menu.Item>
                  )}
                </Menu>
              }
              placement="bottom"
              arrow
            >
              <DisabledButtonStyle>
                <Button>
                  <Iconmoon icon="three-dot-menu" size={16} color="#605E5C" />
                </Button>
              </DisabledButtonStyle>
            </Dropdown>
          }
        </div>
      ),
      align: "center",
    },
  ];
  const onMergeOrderHandler = (record, type) => {
    setMergeSideDrawer(true);
    setNewGradeSideDrawer(false);
    setResendApprovalData(false);
    setSplitOrderSideDrawer(false);
    setProductionDetailsSideDrawer(false);
    if (type == "menuEle") {
      setSelectedOrder(record);
    }
  };
  const handleMergeDrawerClose = () => {
    setMergeSideDrawer(false);
  };

  const handleViewProcessedQtyAction = (record) => {
    if (record) {
      setSelectedOrder(record);
    }
    setNewGradeSideDrawer(false);
    showProcessedQtyDrawer();
  };

  const handleViewPendingQtyAction = (record) => {
    if (record) {
      setSelectedOrder(record);
    }
    setNewGradeSideDrawer(false);
    showPendingQtyDrawer();
  };

  const handlePriorityAction = (record) => {
    setIsVisiblePriorityModal(true);
    setSelectedOrder(record);
  };

  const priorityModalConfirm = async (value) => {
    await prioritizeOrder(value);
    setIsVisiblePriorityModal(false);
    setRendering(true);
    showToaster();
  };

  const prioritizeOrder = async (record) => {
    await changeOrderPriority({
      order: record.orderno,
      prioritize: !record.priority,
    })
      .then((response) =>
        setActionToaster({ error: response.error, msg: response.msg })
      )
      .catch((error) => {
        setActionToaster({
          error: error.response.data.error,
          msg: error.response.data.msg,
        });
      });
  };

  const priorityModalClose = () => {
    setIsVisiblePriorityModal(false);
  };

  // const onViewPODetailsHandler = (record) => {
  //   navigate("../po-details", {
  //     state: {
  //       poNumber: record.savedPO,
  //       backKey: "orderRecords",
  //     },
  //   });
  // };
  const onViewPODetailsHandler = (record) => {

    record?.category === "po"
      ? navigate("../po-details", {
        state: {
          poNumber: record.savedPO,
          backKey: "orderRecords",
          customer: record.customercode,
        },
      })
      : navigate("../so-details", {
        state: {
          soNumber: record.sono,
          backKey: "../order-records",
          isView: true,
          route: "add-new-so",
          dummyOrders: poDetails?.state?.dummyOrders
        },
      });
  };

  const onViewChangeHandler = (record) => {
    navigate("../history", {
      state: {
        order: {
          orderDetails: record,
          route: "../order-records",
          defaultActiveKey: defaultActiveKey,
          defaultOrderState: orderState,
        },
        logType: "Order",
        name: record.orderno,
        searchText: "Search change in order property",
      },
    });
  };

  const handleDelete = (record) => {
    setIsVisibleDeleteModal(true);
    setSelectedOrder(record);
  };

  const deleteModalClose = () => {
    setIsVisibleDeleteModal(false);
    setNewGradeSideDrawer(false);
  };

  const deleteModalConfirm = (orderNo) => {
    setIsVisibleDeleteModal(false);
    deleteOrder(orderNo)
      .then((response) => {
        setActionToaster({
          error: response.error,
          msg: `Order ${orderNo} was successfully deleted`,
        });
        setRendering(true);
        showToaster();
      })
      .catch((error) => {
        console.log("Error in deleting order:", error);
        setActionToaster({
          error: error.response.error,
          msg: error.response.msg,
        });
        setRendering(true);
        showToaster();
      });
    setNewGradeSideDrawer(false);
  };

  const handleRelease = (record) => {
    setIsVisibleReleaseModal(true);
    setSelectedOrder(record);
  };

  const releaseModalConfirm = async (value) => {
    await approveOrder(value.orderno);
    setIsVisibleReleaseModal(false);
  };

  const approveOrder = async (orderNo) => {
    await bulkChangeOrderState([{ order: orderNo, state: "approved" }])
      .then((response) => {
        setActionToaster({
          error: response.error,
          msg: response.msg,
        });
        setRendering(true);
        showToaster();
      })
      .catch((error) => {
        setActionToaster({
          error: error.response.error,
          msg: error.response.msg,
        });
        setRendering(true);
        showToaster();
      });
    setNewGradeSideDrawer(false);
  };

  const releaseModalClose = () => {
    setIsVisibleReleaseModal(false);
    setNewGradeSideDrawer(false);
  };

  const createJCHandler = () => {
    navigate("../../deckle-matching/create-new-job-cards", {
      state: {
        order: allOrdersRecord.map((item) => item.sono)[0].toString(),
        isDummyJC: true
      },
    });
  };

  return quantityDetails && orderManagementSettings ? (
    <RightLayoutContainer>
      <PageTitleComp ref={titleRef} style={{ position: "sticky", top: 58, zIndex: 100, backgroundColor: "#fff", borderBottom: "0" }}>
        <PageHeader
          ghost={false}
          title={`${poDetails?.state?.isSo
              ? soNumber
                ? `SO ${toHandlePOName(soNumber.toUpperCase())} - Orders`
                : "Add Orders"
              : `PO ${toHandlePOName(poDetails?.state?.values?.poNumber?.toUpperCase())} - Orders`
            }`}
          extra={[
            <div className="boxFormType">
              <GlobalSet>
                {!poDetails.state?.dummyOrders && <Button className="themeBtn noBg" onClick={goToOrderRecords}>
                  <Iconmoon icon="order-entry-icon" size={14} color="#ea655b" />
                  {poDetails.state?.backKey == "approveOrders" ||
                    poDetails.state?.backKey == "../approve-records"
                    ? "Go to Approve Orders"
                    : "Go to Order Records"}
                </Button>}
                {!poDetails.state?.dummyOrders && <Button className="themeBtn noBg" onClick={goToPoDetails}>
                  <Iconmoon icon="export" size={14} color="#ea655b" />
                  {poDetails.state.isSo
                    ? "Go to SO details"
                    : "Go to PO details"}
                </Button>
                }
                {poDetails.state?.backKey !== "approveOrders" &&
                  poDetails.state?.backKey !== "../approve-records" && !orderManagementSettings?.fetch_orders_from_erp?.value && !poDetails.state?.dummyOrders && (
                    <Button
                      key="1"
                      className="themeBtn"
                      onClick={approvalHandler}
                      disabled={
                        orderManagementSettings?.fetch_orders_from_erp?.value && (!allOrdersRecord.length ||
                          (!userDetails.roles.order_records.edit_all &&
                            !userDetails.roles.order_records.edit_own))
                      }
                    >
                      <Iconmoon icon="file-check" size={14} color="#ffffff" />
                      Send for approval
                    </Button>
                  )}
                {poDetails.state?.dummyOrders && (
                  <Button
                    key="1"
                    className="themeBtn"
                    onClick={createJCHandler}
                    disabled={
                      !allOrdersRecord.length
                    }
                  >
                    <Iconmoon icon="file-check" size={14} color="#ffffff" />
                    Create Dummy Job Cards
                  </Button>
                )}
              </GlobalSet>
            </div>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <PageTitleComp style={{ borderBottom: "0px solid gray" }}>
        <PageHeader
          className="POPageHeaderSize"
          ghost={false}
          title={orderManagementSettings?.fetch_orders_from_erp?.value ? "" : "Order Details"}

          extra={[
            <div className="boxFormType">
              {(userDetails.roles.order_records.edit_all ||
                userDetails.roles.order_records.edit_own) && (!orderManagementSettings?.fetch_orders_from_erp?.value || poDetails?.state?.route === 'add-new-so') && (
                  <GlobalSet>
                    <Button
                      key="3"
                      className="textTypeBtn textBtnIcon"
                      onClick={handleAddNewOrder}
                    // disabled = {!userDetails.role_type==="ADMIN" && !userDetails.roles.order_records.edit_all && !userDetails.roles.order_records.edit_own}
                    >
                      <Iconmoon icon="addcircle" size={16} color="#EA655B" />
                      Add a new order
                    </Button>
                  </GlobalSet>
                )}
            </div>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      {!orderManagementSettings?.fetch_orders_from_erp?.value && (poDetails?.state?.route === 'add-new-po' || poDetails?.state?.route === 'po-details') && <Row
        gutter={{ xs: 1, sm: 3, md: 6, lg: 12 }}
        style={{ marginBottom: "22px" }}
      >
        <Col
          className="gutter-row"
          style={{ width: "auto", marginBottom: "10px" }}
        >
          <div
            style={{
              padding: "2px 5px 2px",
              backgroundColor: "white",
              borderRadius: "5px",
              border: "1px solid rgb(192 199 192)",
              height: "fit-content",
            }}
          >
            <div className="row" style={{ paddingTop: "5px" }}>
              <div className="col-8">
                <div style={{ fontSize: "12px", color: "var(--para-text)" }}>
                  {quantityDetails?.pending_weight
                    ? "Pending Qty : " +
                    (" (" +
                      quantityDetails?.pending_weight?.toFixed(3) +
                      " " +
                      (measurementData?.data
                        ? capitalize(
                          weightUnit[
                            measurementData?.data?.units_management?.weight
                              ?.default
                          ]?.displayName
                        )
                        : "T") +
                      ")")
                    : "Pending Qty : " +
                    " (0.000" +
                    " " +
                    (measurementData?.data
                      ? capitalize(
                        weightUnit[
                          measurementData?.data?.units_management?.weight
                            ?.default
                        ]?.displayName
                      )
                      : "T") +
                    ")"}
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col
          className="gutter-row"
          style={{ width: "auto", marginBottom: "10px" }}
        >
          <div
            style={{
              padding: "2px 5px 2px",
              backgroundColor: "#edebe9",
              borderRadius: "8px",
              border: "1px solid #edebe9",
              height: "fit-content",
            }}
          >
            <div class="row" style={{ paddingTop: "5px" }}>
              <div class="col-8">
                <div style={{ fontSize: "12px", color: "#6a6866" }}>
                  {/* { quantityDetails?.open_orders?.["numbers"] <= 1 ? 
                            ((quantityDetails?.open_orders?.["numbers"] ? quantityDetails?.open_orders?.["numbers"] : "0")  + " Open Order "  + " (" + (quantityDetails?.open_orders?.["quantity"] ? quantityDetails?.open_orders?.["quantity"].toFixed(3): "0.000") + " Tonnes)") : 
                            ((quantityDetails?.open_orders?.["numbers"] ? quantityDetails?.open_orders?.["numbers"] : "0" ) + " Open Orders "  + " (" + (quantityDetails?.open_orders?.["numbers"] ? quantityDetails?.open_orders?.["quantity"].toFixed(3): "0.000") + " Tonnes)")} 
                         */}
                  {quantityDetails?.planned_weight
                    ? "Planned to be produced Qty : " +
                    (" (" +
                      quantityDetails?.planned_weight?.toFixed(3) +
                      " " +
                      (measurementData?.data
                        ? capitalize(
                          weightUnit[
                            measurementData?.data?.units_management?.weight
                              ?.default
                          ]?.displayName
                        )
                        : "T") +
                      ")")
                    : "Planned to be produced Qty : " +
                    " (0.000" +
                    " " +
                    (measurementData?.data
                      ? capitalize(
                        weightUnit[
                          measurementData?.data?.units_management?.weight
                            ?.default
                        ]?.displayName
                      )
                      : "T") +
                    ")"}
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col
          className="gutter-row"
          style={{ width: "auto", marginBottom: "10px" }}
        >
          <div
            style={{
              padding: "2px 5px 2px",
              backgroundColor: "#ecf9f0",
              borderRadius: "8px",
              border: "1px solid #ecf9f0",
              height: "fit-content",
              width: "auto",
            }}
          >
            <div class="row" style={{ paddingTop: "5px" }}>
              <div class="col-8">
                <div style={{ fontSize: "12px", color: "#107c10" }}>
                  {/* { quantityDetails?.approved_orders?.["numbers"] <= 1 ? 
                            ((quantityDetails?.approved_orders?.["numbers"] ? quantityDetails?.approved_orders?.["numbers"] : "0")  + " Approved Order "  + " (" + ((quantityDetails?.approved_orders?.["quantity"] ? quantityDetails?.approved_orders?.["quantity"].toFixed(3) : "0.000") + " Tonnes)")) : 
                            ((quantityDetails?.approved_orders?.["numbers"] ? quantityDetails?.approved_orders?.["numbers"] : "0") + " Approved Orders "  + " (" + (quantityDetails?.approved_orders?.["quantity"] ? quantityDetails?.approved_orders?.["quantity"].toFixed(3) : " 0.000")+ " Tonnes)")} */}
                  {quantityDetails?.in_production_weight
                    ? "In Production Qty : " +
                    (" (" +
                      quantityDetails?.in_production_weight?.toFixed(3) +
                      " " +
                      (measurementData?.data
                        ? capitalize(
                          weightUnit[
                            measurementData?.data?.units_management?.weight
                              ?.default
                          ]?.displayName
                        )
                        : "T") +
                      ")")
                    : "In Production Qty : " +
                    " (0.000" +
                    " " +
                    (measurementData?.data
                      ? capitalize(
                        weightUnit[
                          measurementData?.data?.units_management?.weight
                            ?.default
                        ]?.displayName
                      )
                      : "T") +
                    ")"}
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col
          className="gutter-row"
          style={{ width: "auto", marginBottom: "10px" }}
        >
          <div
            style={{
              padding: "2px 5px 2px",
              backgroundColor: "#e3effc",
              borderRadius: "8px",
              border: "1px solid #e3effc",
              height: "fit-content",
              width: "auto",
            }}
          >
            <div class="row" style={{ paddingTop: "5px" }}>
              <div class="col-8">
                <div style={{ fontSize: "12px", color: "#3485e0" }}>
                  {/* { quantityDetails?.pending_orders?.["numbers"] <= 1 ? 
                            (( quantityDetails?.pending_orders?.["numbers"] ? quantityDetails?.pending_orders?.["numbers"] : "0")  + " Pending Order "  + " (" + (quantityDetails?.pending_orders?.["quantity"] ? quantityDetails?.pending_orders?.["quantity"].toFixed(3) : "0.000" ) + " Tonnes)") : 
                            ((quantityDetails?.pending_orders?.["numbers"] ? quantityDetails?.pending_orders?.["numbers"] : "0")  + " Pending Orders "  + " (" + (quantityDetails?.pending_orders?.["quantity"] ? quantityDetails?.pending_orders?.["quantity"].toFixed(3): "0.000" ) + " Tonnes)")} */}
                  {quantityDetails?.completed_weight
                    ? "Produced Qty : " +
                    (" (" +
                      quantityDetails?.completed_weight?.toFixed(3) +
                      " " +
                      (measurementData?.data
                        ? capitalize(
                          weightUnit[
                            measurementData?.data?.units_management?.weight
                              ?.default
                          ]?.displayName
                        )
                        : "T") +
                      ")")
                    : "Produced Qty : " +
                    " (0.000" +
                    " " +
                    (measurementData?.data
                      ? capitalize(
                        weightUnit[
                          measurementData?.data?.units_management?.weight
                            ?.default
                        ]?.displayName
                      )
                      : "T") +
                    ")"}
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col
          className="gutter-row"
          style={{ width: "auto", marginBottom: "10px" }}
        >
          <div
            style={{
              padding: "2px 5px 2px",
              backgroundColor: "#fef5e6",
              borderRadius: "8px",
              border: "1px solid #fef5e6",
              height: "fit-content",
              width: "auto",
            }}
          >
            <div class="row" style={{ paddingTop: "5px" }}>
              <div class="col-8">
                <div style={{ fontSize: "12px", color: "#cd9436" }}>
                  {/* { quantityDetails?.review_orders?.["numbers"] <= 1 ? 
                          ((quantityDetails?.review_orders?.["numbers"] ? quantityDetails?.review_orders?.["numbers"] : "0") + " Changes Requested Order "  + " (" + ((quantityDetails?.review_orders?.["quantity"] ? quantityDetails?.review_orders?.["quantity"].toFixed(3): "0.000" )+ " Tonnes)")) : 
                          ((quantityDetails?.review_orders?.["numbers"] ? quantityDetails?.review_orders?.["numbers"] : "0") + " Changes Requested Orders "  + " (" + ((quantityDetails?.review_orders?.["quantity"] ? quantityDetails?.review_orders?.["quantity"].toFixed(3): "0.000") + " Tonnes)"))} */}

                  {quantityDetails?.packaged_weight
                    ? "Packaged Qty : " +
                    (" (" +
                      quantityDetails?.packaged_weight?.toFixed(3) +
                      " " +
                      (measurementData?.data
                        ? capitalize(
                          weightUnit[
                            measurementData?.data?.units_management?.weight
                              ?.default
                          ]?.displayName
                        )
                        : "T") +
                      ")")
                    : "Packaged Qty : " +
                    " (0.000" +
                    " " +
                    (measurementData?.data
                      ? capitalize(
                        weightUnit[
                          measurementData?.data?.units_management?.weight
                            ?.default
                        ]?.displayName
                      )
                      : "T") +
                    ")"}
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col
          className="gutter-row"
          style={{ width: "auto", marginBottom: "10px" }}
        >
          <div
            style={{
              padding: "2px 5px 2px",
              backgroundColor: "#fdeeea",
              borderRadius: "8px",
              border: "1px solid #fdeeea",
              height: "fit-content",
              width: "auto",
            }}
          >
            <div class="row" style={{ paddingTop: "5px" }}>
              <div class="col-8">
                <div style={{ fontSize: "12px", color: "#ea4e2c" }}>
                  {/* { quantityDetails?.on_hold_orders?.["numbers"] <= 1 ? 
                            ((quantityDetails?.on_hold_orders?.["numbers"] ? quantityDetails?.on_hold_orders?.["numbers"] : "0") + " On Hold Order "  + " ("+ ((quantityDetails?.on_hold_orders?.["quantity"] ? quantityDetails?.on_hold_orders?.["quantity"].toFixed(3) : "0.000")+ " Tonnes)")) : 
                            ((quantityDetails?.on_hold_orders?.["numbers"] ? quantityDetails?.on_hold_orders?.["numbers"] : "0")+ " On Hold Orders "  + " (" + ((quantityDetails?.on_hold_orders?.["quantity"] ? quantityDetails?.on_hold_orders?.["quantity"].toFixed(3) :"0.000")+ " Tonnes)"))} */}
                  {quantityDetails?.dispatched_weight
                    ? "Dispatched Qty : " +
                    (" (" +
                      quantityDetails?.dispatched_weight?.toFixed(3) +
                      " " +
                      (measurementData?.data
                        ? capitalize(
                          weightUnit[
                            measurementData?.data?.units_management?.weight
                              ?.default
                          ]?.displayName
                        )
                        : "T") +
                      ")")
                    : "Dispatched Qty : " +
                    " (0.000" +
                    " " +
                    (measurementData?.data
                      ? capitalize(
                        weightUnit[
                          measurementData?.data?.units_management?.weight
                            ?.default
                        ]?.displayName
                      )
                      : "T") +
                    ")"}
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col
          className="gutter-row"
          style={{ width: "auto", marginBottom: "10px" }}
        >
          <div
            style={{
              padding: "2px 5px 2px",
              backgroundColor: "#fdeeea",
              borderRadius: "8px",
              border: "1px solid #fdeeea",
              height: "fit-content",
              width: "auto",
            }}
          >
            <div class="row" style={{ paddingTop: "5px" }}>
              <div class="col-8">
                <div style={{ fontSize: "12px", color: "#ea4e2c" }}>
                  {/* { quantityDetails?.rejected_orders?.["numbers"] <= 1 ? 
                          ((quantityDetails?.rejected_orders?.["numbers"] ? quantityDetails?.rejected_orders?.["numbers"] : "0") + " Rejected Order "  + " (" + ((quantityDetails?.rejected_orders?.["quantity"] ? quantityDetails?.rejected_orders?.["quantity"].toFixed(3) :" 0.000")+ " Tonnes)")): 
                          ((quantityDetails?.rejected_orders?.["numbers"] ? quantityDetails?.rejected_orders?.["numbers"] : "0") + " Rejected Orders "  + " (" +  ((quantityDetails?.rejected_orders?.["quantity"] ? quantityDetails?.rejected_orders?.["quantity"].toFixed(3) : "0.000")+ " Tonnes)"))} */}
                  {quantityDetails?.cancelled_weight
                    ? "Cancelled Qty : " +
                    (" (" +
                      quantityDetails?.cancelled_weight?.toFixed(3) +
                      " " +
                      (measurementData?.data
                        ? capitalize(
                          weightUnit[
                            measurementData?.data?.units_management?.weight
                              ?.default
                          ]?.displayName
                        )
                        : "T") +
                      ")")
                    : "Cancelled Qty : " +
                    " (0.000" +
                    " " +
                    (measurementData?.data
                      ? capitalize(
                        weightUnit[
                          measurementData?.data?.units_management?.weight
                            ?.default
                        ]?.displayName
                      )
                      : "T") +
                    ")"}
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col
          className="gutter-row"
          style={{ width: "auto", marginBottom: "10px" }}
        >
          <div
            style={{
              padding: "2px 5px 2px",
              backgroundColor: "#ecf9f0",
              borderRadius: "8px",
              border: "1px solid #ecf9f0",
              height: "fit-content",
              width: "auto",
            }}
          >
            <div class="row" style={{ paddingTop: "5px" }}>
              <div class="col-8">
                <div style={{ fontSize: "12px", color: "#107c10" }}>
                  {/* { quantityDetails?.completed_orders?.["numbers"] <= 1 ? 
                          ((quantityDetails?.completed_orders?.["numbers"] ? quantityDetails?.completed_orders?.["numbers"] : "0")  + " Completed Order "  +  " (" +  (( quantityDetails?.completed_orders?.["quantity"] ? quantityDetails?.completed_orders?.["quantity"].toFixed(3): "0.000") + " Tonnes)")) : 
                          ((quantityDetails?.completed_orders?.["numbers"] ? quantityDetails?.completed_orders?.["numbers"] : "0") + " Completed Orders "  + " (" +   ((quantityDetails?.completed_orders?.["quantity"] ? quantityDetails?.completed_orders?.["quantity"].toFixed(3): "0.000" ) + " Tonnes)"))} */}

                  {quantityDetails?.on_hold_weight
                    ? "On Hold Qty : " +
                    (" (" +
                      quantityDetails?.on_hold_weight?.toFixed(3) +
                      " " +
                      (measurementData?.data
                        ? capitalize(
                          weightUnit[
                            measurementData?.data?.units_management?.weight
                              ?.default
                          ]?.displayName
                        )
                        : "T") +
                      ")")
                    : "On Hold Qty : " +
                    " (0.000" +
                    " " +
                    (measurementData?.data
                      ? capitalize(
                        weightUnit[
                          measurementData?.data?.units_management?.weight
                            ?.default
                        ]?.displayName
                      )
                      : "T") +
                    ")"}
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>}
      <style dangerouslySetInnerHTML={{
        __html: `
        .ant-table-sticky-holder {
          z-index: 101 !important;
        }
      `}} />
      <TableLayoutData>
        <div className="tableDataFormat">
          {loading ? (
            <TableShimmer header={columnsHead} scroll={3000} />
          ) : (
            <Table
              // columns={columnsHead}
              columns={(orderManagementSettings?.fetch_balance_quantity?.value) ? (columnsHead) : (columnsHead?.filter(ele => ele.dataIndex !== "balance_qty"))}
              dataSource={allOrdersRecord}
              onChange={onChange}
              pagination={{
                current: currentPage,
                total: allOrdersRecord?.length,
                showTitle: false,
                showTotal: (total, range) =>
                  `Showing ${range[0]}-${range[1]} of ${total} results`,
                pageSizeOptions: [10, 20, 50, 100],
                showSizeChanger: true,
              }}
              scroll={{ x: 3000 }}
              sticky={{
                offsetHeader: tableStickyOffset,
                getContainer: () => {
                  let node = document.getElementById('right-layout-container');
                  while (node && node !== document.body) {
                    const style = window.getComputedStyle(node);
                    if (style.overflowY === 'auto' || style.overflowY === 'scroll') return node;
                    node = node.parentNode;
                  }
                  return window;
                }
              }}
              rowClassName={(record) => record.priority && "true"}
            />
          )}
        </div>
      </TableLayoutData>

      {/* Toasters */}

      {visibleToaster && (
        <AlertContainer
          setClose={setVisibleToaster}
          color={actionToaster.error ? "red toaster" : "green toaster"}
          icon={actionToaster.error ? alertRed : alertGreen}
          msg={actionToaster.msg}
          closeIcon={true}
        />
      )}

      {showAlert && (
        <AlertContainer
          setClose={setShowAlert}
          color="red toaster"
          icon={alertYellow}
          msg="No open orders to send for approval"
        />
      )}
      {successApproval && (
        <AlertContainer
          color="green toaster"
          icon={alertGreen}
          msg={`The ${poDetails?.state?.isSo ? "SO" : "PO"} ${poDetails?.state?.isSo ? poDetails.state.values?.soNumber : toHandlePOName(poDetails.state.values.poNumber)} is successfully sent to the approver for order approval`}
        />
      )}

      {visibleToaster && !actionToaster.error && (
        <AlertContainer
          color="green toaster"
          icon={alertGreen}
          msg={actionToaster.msg}
        />
      )}
      {visibleToaster && actionToaster.error && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg={actionToaster.msg}
        />
      )}

      {/* {newOrderDrawer && (<AddNewOrderData
        visible={newOrderDrawer}
        onClose={onCloseAddNewOrder}
        onCloseGrade={onCloseAddNewOrder}
        rendering={setRendering}
        poDetails={poDetails.state.values}
        toasterAction={setActionToaster}
        showToaster={() => showToaster(setVisibleToaster)}
        isOrders={allOrdersRecord.length ? true : false}
      ></AddNewOrderData>)} */}

      {newOrderDrawer && (
        <MultiDiaAddOrderDrawer
          visible={newOrderDrawer}
          onClose={onCloseAddNewOrder}
          onCloseGrade={onCloseAddNewOrder}
          rendering={setRendering}
          poDetails={poDetails.state.values}
          toasterAction={setActionToaster}
          showToaster={() => showToaster(setVisibleToaster)}
          isOrders={allOrdersRecord.length ? true : false}
          isSo={poDetails.state.isSo}
          soNumber={soNumber}
          setSoNumber={setSoNumber}
          uploadDocument={poDetails.state.uploadDocument}
        ></MultiDiaAddOrderDrawer>
      )}
      {newDummyOrderDrawer && (
        // <AddDummyOrderDrawer
        //   visible={newDummyOrderDrawer}
        //   onClose={onCloseAddNewOrder}
        //   onCloseGrade={onCloseAddNewOrder}
        //   rendering={setRendering}
        //   poDetails={poDetails.state.values}
        //   toasterAction={setActionToaster}
        //   showToaster={() => showToaster(setVisibleToaster)}
        //   isOrders={allOrdersRecord.length ? true : false}
        //   isSo={poDetails.state.isSo}
        //   soNumber={soNumber}
        //   setSoNumber={setSoNumber}
        //   uploadDocument={poDetails.state.uploadDocument}
        // ></AddDummyOrderDrawer>
        <AddNewDummyOrderDrawer
          visible={newDummyOrderDrawer}
          onClose={onCloseAddNewOrder}
          onCloseGrade={onCloseAddNewOrder}
          rendering={setRendering}
          poDetails={poDetails.state.values}
          toasterAction={setActionToaster}
          showToaster={() => showToaster(setVisibleToaster)}
          isOrders={allOrdersRecord.length ? true : false}
          isSo={poDetails.state.isSo}
          soNumber={soNumber}
          setSoNumber={setSoNumber}
          uploadDocument={poDetails.state.uploadDocument}
        />
      )}

      {/* {NewGradeSideDrawer && (<EditNewOrderDrawer
        visible={NewGradeSideDrawer}
        onClose={onCloseNewGrade}
        setDrawer={setNewGradeSideDrawer}
        onShowPo={showPoPage}
        onCloseGrade={onCloseFullNewGrade}
        selectedOrderNo={selectedOrder?.orderno}
        selectedState={selectedOrder?.status}
        selectedOrder={selectedOrder}
        toasterAction={setActionToaster}
        showToaster={() => showToaster(setVisibleToaster)}
        isDeleted={setIsDeleted}
        rendering={setRendering}
        roles={userDetails.roles.order_records}
        setMergeSideDrawer={onMergeOrderHandler}
        handleCancel={handleCancel}
        handleRestore={handleRestore}
        pageType = {"PORecord"}
        backKey = {poDetails.state.backKey}
        values = {poDetails.state.values}
        route = {poDetails.state.route}
      ></EditNewOrderDrawer>)} */}

      {NewGradeSideDrawer && (
        <MultiDiaEditOrderDrawer
          visible={NewGradeSideDrawer}
          onClose={onCloseNewGrade}
          onCloseGrade={onCloseFullNewGrade}
          onShowPo={showPoPage}
          setDrawer={setNewGradeSideDrawer}
          selectedOrderNo={selectedOrder?.orderno}
          selectedState={selectedOrder?.status}
          selectedOrder={selectedOrder}
          rendering={setRendering}
          toasterAction={setActionToaster}
          showToaster={showToaster}
          roles={userDetails?.roles.order_records}
          handleCancel={handleCancel}
          handleRestore={handleRestore}
          setMergeSideDrawer={onMergeOrderHandler}
          handleViewProdDrawer={handleViewProdDetailsAction}
          handleViewProcessedQtyDrawer={handleViewProcessedQtyDetails}
          handleViewPendingQtyDrawer={handleViewPendingQtyDetails}
          handleCancelQuantity={handleCancelledQuantityAction}
          handleSplitDrawer={showNewSplitOrderDrawer}
          handleHold={handleHold}
          pageType={"PORecord"}
          backKey={poDetails.state.backKey}
          values={poDetails.state.values}
          route={poDetails.state.route}
          // defaultActiveKey={defaultActiveKey}
          // defaultOrderState={orderState}
          actionType="view"
          type="orderRecord"
          category={selectedOrder?.category.toLowerCase()}
        ></MultiDiaEditOrderDrawer>
      )}

      {/* {resendApprovalData && (<ResendApprovalData
        visible={resendApprovalData}
        onClose={onCloseResendApproval}
        onCloseGrade={onCloseFullNewGrade}
        selectedOrderNo={selectedOrder?.orderno}
        selectedState={selectedOrder?.status}
        rendering={setRendering}
        toasterAction={setActionToaster}
        showToaster={() => showToaster(setVisibleToaster)}
        isEditFromIncompleteOrder={
          selectedOrder?.status == "Approved" ? true : false
        }
        type="orderRecord"
      ></ResendApprovalData>)} */}

      {resendApprovalData && (
        <MultiDiaEditOrderDrawer
          visible={resendApprovalData}
          onClose={onCloseResendApproval}
          onCloseGrade={onCloseFullNewGrade}
          selectedOrderNo={selectedOrder?.orderno}
          selectedState={selectedOrder?.status}
          rendering={setRendering}
          toasterAction={setActionToaster}
          showToaster={() => showToaster(setVisibleToaster)}
          isEditFromIncompleteOrder={
            selectedOrder?.status == "Active" ? true : false
          }
          type="orderRecord"
          category={selectedOrder?.category.toLowerCase()}
        ></MultiDiaEditOrderDrawer>
      )}

      <SplitOrderDrawer
        visible={splitOrderSideDrawer}
        onClose={onCloseNewGrade}
        onCloseGrade={onCloseFullNewGrade}
        onShowPo={showPoPage}
        setDrawer={setSplitOrderSideDrawer}
        selectedOrderNo={selectedOrder?.orderno}
        selectedProduct={selectedOrder?.productcode}
        selectedState={selectedOrder?.status}
        selectedCustomerCode={selectedOrder?.customercode}
        rendering={setRendering}
        toasterAction={setActionToaster}
        showToaster={showToaster}
        roles={userDetails?.roles.order_records}
      ></SplitOrderDrawer>

      {mergeSideDrawer && (
        <MergeDrawer
          visible={mergeSideDrawer}
          handleMergeDrawerClose={handleMergeDrawerClose}
          parent={selectedOrder?.parent}
          other_parents={selectedOrder?.other_parents}
          orderDetails={selectedOrder ? selectedOrder : {}}
          toasterAction={setActionToaster}
          showToaster={showToaster}
          rendering={setRendering}
        ></MergeDrawer>
      )}

      {productionDetailsSideDrawer && (
        <ProductionDetailsDrawer
          visible={productionDetailsSideDrawer}
          onCloseGrade={onCloseFullNewGrade}
          selectedOrderNo={selectedOrder?.orderno}
          handleCancel={onCloseFullNewGrade}
        ></ProductionDetailsDrawer>
      )}

      {processedQtyDetailsSideDrawer && (
        <ViewProcessedQuantityDrawer
          visible={processedQtyDetailsSideDrawer}
          onCloseGrade={onCloseFullNewGrade}
          selectedOrderNo={selectedOrder?.orderno}
          handleCancel={onCloseFullNewGrade}
        ></ViewProcessedQuantityDrawer>
      )}

      {pendingQtyDetailsSideDrawer && (
        <ViewPendingQuantityDrawer
          visible={pendingQtyDetailsSideDrawer}
          onCloseGrade={onCloseFullNewGrade}
          selectedOrderNo={selectedOrder?.orderno}
          handleCancel={onCloseFullNewGrade}
        ></ViewPendingQuantityDrawer>
      )}

      {cancelQuantitySideDrawer && (
        <CancelQuantityDrawer
          visible={cancelQuantitySideDrawer}
          selectedOrderNo={selectedOrder?.orderno}
          onClose={handleCancelQuantityDrawerClose}
          toasterAction={setActionToaster}
          showToaster={showToaster}
          rendering={setRendering}
        ></CancelQuantityDrawer>
      )}

      <ActionDrawer
        type={"cancel"}
        visible={holdOrders}
        onClose={onCloseActionDrawer}
        onCloseGrade={onCloseActionDrawer}
        orderNo={selectedOrder?.orderno}
        reFetch={setRendering}
        setActionResponse={setActionToaster}
        showToaster={() => showToaster(setVisibleToaster)}
      >
        <h5>Reason for Cancellation</h5>
        <p>Please specify the reason for cancellation</p>
      </ActionDrawer>

      {holdOrderDrawer && (
        <ActionDrawer
          type={"hold"}
          visible={holdOrderDrawer}
          onClose={onCloseActionDrawer}
          onCloseGrade={onCloseActionDrawer}
          orderNo={selectedOrder?.orderno}
          reFetch={setRendering}
          setActionResponse={setActionToaster}
          showToaster={showToaster}
        >
          <h5>Reason for holding the order</h5>
          <p>Please specify the reason</p>
        </ActionDrawer>
      )}

      {/* Modals- Approve orders */}
      <ModalPopup visible={isVisibleModal}>
        <div className="Popup-img">
          <img src={warning} alt="Warning" />
        </div>
        <div className="Popup-content">
          <span>Are you sure?</span>
          <p>
            You are about to send {poDetails?.state?.isSo ? "SO" : "PO"} for
            approval, are you sure you want to proceed
          </p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => modalClose()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>

          <Button
            key="submit"
            className="themeBtn"
            onClick={() => modalConfirm()}
          >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup>

      <ConfirmationModal
        visible={isVisiblePriorityModal}
        icon={warning}
        param={selectedOrder}
        confirmAction={priorityModalConfirm}
        cancelAction={priorityModalClose}
      >
        <span>
          {selectedOrder?.priority ? "Remove priority?" : "Prioritize Order?"}
        </span>
        <p>
          {selectedOrder?.priority
            ? "The order will be treated as a regular order. Are you sure you want to continue?"
            : "The order will be upgraded to a prioritized order and will be completely matched in deckle. Are you sure you want to proceed?"}
        </p>
      </ConfirmationModal>

      <ModalPopup visible={isVisibleDeleteModal}>
        <div className="Popup-img">
          <img src={warning} alt="Warning" />
        </div>
        <div className="Popup-content">
          <span>Delete Order?</span>
          <p>
            You will not be able to recover the order if you delete it. Are you
            sure you want to proceed?
          </p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => deleteModalClose()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>

          <Button
            key="submit"
            className="themeBtn"
            onClick={() => deleteModalConfirm(selectedOrder?.orderno)}
          >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup>

      <ConfirmationModal
        visible={isVisibleReleaseModal}
        icon={warning}
        param={selectedOrder}
        confirmAction={releaseModalConfirm}
        cancelAction={releaseModalClose}
      >
        <span> {"Release order for production?"} </span>
        <p>
          {
            "The order will be matched in next deckle. Are you sure you want to proceed?"
          }
        </p>
      </ConfirmationModal>
    </RightLayoutContainer>
  ) : (
    ""
  );
};

export default OrderDetailsData;
